import { render, staticRenderFns } from "./AddCaption.vue?vue&type=template&id=02487a59&scoped=true&"
import script from "./AddCaption.vue?vue&type=script&lang=js&"
export * from "./AddCaption.vue?vue&type=script&lang=js&"
import style0 from "./AddCaption.vue?vue&type=style&index=0&id=02487a59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02487a59",
  null
  
)

export default component.exports